import script from "./FoundationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundationPage.vue?vue&type=script&setup=true&lang=js"

import "./FoundationPage.vue?vue&type=style&index=0&id=072ef78c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072ef78c"]])

export default __exports__